import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import { ReactNode } from "react";
import "./index.css";

/** Opens on hover and focus; pass `open` to also open it on click or tap. */
export function Tooltip({
  children,
  open,
  onOpenChange,
}: {
  children: ReactNode;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}) {
  return (
    <TooltipPrimitive.Provider delayDuration={200}>
      <TooltipPrimitive.Root open={open} onOpenChange={onOpenChange}>
        {children}
      </TooltipPrimitive.Root>
    </TooltipPrimitive.Provider>
  );
}

export function TooltipTrigger({ children }: { children: ReactNode }) {
  return (
    <TooltipPrimitive.Trigger asChild>{children}</TooltipPrimitive.Trigger>
  );
}

export function TooltipContent({ children }: { children: ReactNode }) {
  return (
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Content className="TooltipContent z-50" sideOffset={5}>
        {children}
        <TooltipPrimitive.Arrow className="TooltipArrow" />
      </TooltipPrimitive.Content>
    </TooltipPrimitive.Portal>
  );
}
